"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconCounterButton = void 0;
var _react = _interopRequireWildcard(require("react"));
var _formatCount = require("@cbhq/cds-common/utils/formatCount");
var _icons = require("../icons");
var _layout = require("../layout");
var _system = require("../system");
var _typography = require("../typography");
const _excluded = ["icon", "iconSize", "count", "color", "dangerouslySetColor"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const IconCounterButton = /*#__PURE__*/(0, _react.memo)( /*#__PURE__*/(0, _react.forwardRef)(function IconCounterButton(_ref, ref) {
  let icon = _ref.icon,
    _ref$iconSize = _ref.iconSize,
    iconSize = _ref$iconSize === void 0 ? 's' : _ref$iconSize,
    _ref$count = _ref.count,
    count = _ref$count === void 0 ? 0 : _ref$count,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'foreground' : _ref$color,
    dangerouslySetColor = _ref.dangerouslySetColor,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_system.Pressable, _extends({
    ref: ref,
    background: "transparent"
  }, props), /*#__PURE__*/_react.default.createElement(_layout.HStack, {
    alignItems: "center",
    gap: 1
  }, typeof icon === 'string' ? /*#__PURE__*/_react.default.createElement(_icons.Icon, {
    color: color,
    dangerouslySetColor: dangerouslySetColor,
    name: icon,
    size: iconSize
  }) : icon, count > 0 ? /*#__PURE__*/_react.default.createElement(_typography.TextLabel1, {
    mono: true,
    as: "p"
  }, (0, _formatCount.formatCount)(count)) : null));
}));
exports.IconCounterButton = IconCounterButton;